module.exports = __webpack_public_path__ + "static/media/darkness-icon.fab49a18.png";